import config from '../../config/service';
import _ from 'lodash';
import { WebsocketModule } from '@/store/modules/websocket';
const random = String(_.random(5,true)).substring(2); // 随机数
// const socketUrl = 'ws://192.168.1.182:8083/' + config.webSocketService + '/imserver';
// const socketUrl = `ws://${ window.location.hostname }:8117/gykj-websocket/show/${ random }`;// 地址
const socketUrl = `ws://192.168.1.228:30018/gykj-websocket/imserver/${ random }`;// 地址

export default class Websocket {
    public $ws?: any;
    public lockReturn?: boolean = false;
    public timeout?: any = 60 * 1000 * 5;
    public timeoutObj?: any;
    public timeoutNum?: any;
    public serverTimeoutObj?: any;
    public userId?: string;

    constructor(userId: any) {
        this.userId = userId;
        this.wsError = this.wsError.bind(this);
        this.wsOpen = this.wsOpen.bind(this);
        this.wsMsg = this.wsMsg.bind(this);
        this.initWebSocket()
    }

    public initWebSocket() {
        // this.$ws = new WebSocket(socketUrl + '/' + this.userId);// 写入地址 这里的地址可以在initWebSocket方法加入参数
        this.$ws = new WebSocket(socketUrl);// 写入地址 这里的地址可以在initWebSocket方法加入参数
        this.$ws.onopen = this.wsOpen;
        this.$ws.onclose = this.wsClose;
        this.$ws.onmessage = this.wsMsg;
        this.$ws.onerror = this.wsError;
    }

    // 开启websocket
    public wsOpen(e: any) {
        this.startWsHeartbeat();
        // console.log(this.$ws,'ws');
        console.log('ws open');
    }

    // 关闭websocket
    public wsClose(e: any) {
        console.log(e, 'close');
        console.log('ws close');
    }

    // 关闭websocket
    public wsMsg(msg: any) {
        // this.globalCallback(JSON.parse(msg));
        this.resetHeartbeat();
        console.log(msg, 'ws msg');
    }

    // 异常处理
    public wsError(err: any) {
        console.log(err, 'ws error');
        this.reconnect();
    }

    // 开始心跳监测
    public startWsHeartbeat() {
        const _this = this;
        if (_this.timeoutObj) clearTimeout(_this.timeoutObj);
        if (_this.serverTimeoutObj) clearTimeout(_this.serverTimeoutObj);
        _this.timeoutObj = setInterval(function () {
            // 判断websocket当前状态
            if (_this.$ws.readyState !== 1) {
                _this.reconnect()
            }
        }, _this.timeout);
    }

    // 重启
    private reconnect() {
        const _this = this;
        if (_this.lockReturn) {
            return;
        }
        _this.lockReturn = true;
        if (_this.timeoutNum) clearTimeout(_this.timeoutNum);
        _this.timeoutNum = setTimeout(function () {
            _this.initWebSocket();
            _this.lockReturn = false;
        }, 3000);
    }

    // 重置websocket心跳
    public resetHeartbeat() {
        const _this = this;
        clearTimeout(_this.timeoutObj);
        clearTimeout(_this.serverTimeoutObj);
        _this.startWsHeartbeat();
    }

    // 发送消息
    public sendMessage(data: any) {
        if (this.$ws.readyState === this.$ws.OPEN) {
            this.$ws.send(JSON.stringify(data))
        } else {
            setTimeout(() => {
                this.sendMessage(data);
            })
        }
    }
}

